import { Button, Popconfirm } from "antd";
import type { TClickAction } from "../dataTypes";

export const ActionButton: React.FC<{ config: TClickAction }> = ({ config }) => {
  const { label, onClick, confirm, ...buttonProps } = config;

  const button = (
    <Button
      {...buttonProps}
      onClick={confirm ? undefined : onClick}
      style={{ whiteSpace: "nowrap" }}
    >
      {!buttonProps.icon && label}
    </Button>
  );

  if (confirm) {
    return (
      <Popconfirm
        title={confirm.title}
        // description={confirm.description}
        onConfirm={onClick}
        okText={confirm.okText ?? "Yes"}
        cancelText={confirm.cancelText ?? "No"}
        disabled={buttonProps.disabled}
      >
        {button}
      </Popconfirm>
    );
  }

  return button;
};
